import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';
import '../../css/CustomerCard.css';
import { PagingTable,SelectField,MessageBox } from 'component-lib';
import { CustomerModel, RequestAjaxClass, DocumentsModel } from 'models-lib';

class DocumentUpload extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerData";
        this.state.DocumentList=[];
        this.CustomerId = props.id;
        this.state.Upload=false;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.state.School = false;
        this.state.SchoolId = 1;

        this.CustomerModel = new CustomerModel([this]);
        this.DocumentsModel = new DocumentsModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Labels["Forms"]);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.CustomerModel.SetRequest(this.Request);
        this.DocumentsModel.SetRequest(this.Request);
        this.CustomerModel.GetSchoolsOfCustomer();
    }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
            if(observer === "SchoolsCustomer"){
                let data = this.CustomerModel.Schools;
                let schools = [];
                for (let i= 0; i<data.length; i++){
                    let school = { Key:data[i].Id, Display:data[i].Name1 };
                    schools.push(school);
                }
                me.refs.school.setState({ Data:schools });
            }
            else if(observer === "Documents"){
                let documents = [];
                this.DocumentsModel.Documents.forEach(function(value) {
                    let document = {};
                    document.Id = value.Id;
                    document.FileName = value.FileName;
                    document.FileSize = value.FileSize;
                    documents.push(document);
                });
                
                if (me.refs.table){
                    me.refs.table.setState({ Data: documents, Count: this.DocumentsModel.Count, Limit: this.DocumentsModel.Limit, Start: this.DocumentsModel.Start, End: this.DocumentsModel.Start+documents.length });
                }
                me.setState({ Count:this.DocumentsModel.Count });
                $("#LoadingIcon").removeClass().addClass('hide');
            }
            else if(observer === "DeleteDocument"){
                ReactDOM.render(<MessageBox 
                    AppURL={Vas.ApplicationUrl} 
                    Message={Vas.Resources.Labels["DocumentDeleteSuccess"]} 
                    Title={Vas.Resources.Titles["Note"]} />
                      , document.getElementById('messageContainer'));    
                me.load(me.refs.table.PrepareSendData());
                $("#LoadingIcon").removeClass().addClass('hide');
            }
        });
    }

    Upload(){
        if (document.getElementById('Schools2').selectedIndex > 0){
            this.setState({ Upload:true },()=>{
                localStorage.setItem('DocumentSchoolUpload',true);
                Vas.GetView("CustomerDocumentUpload",{CustomerId : this.state.SchoolId},true);
            });
        } else {
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["NoSchool"]} 
              Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
        }
    }

    load(sendData){
        if (document.getElementById('Schools2').selectedIndex > 0){
            this.DocumentsModel.GetDocumentsByCustomerId(this.state.SchoolId,sendData);
        } else {
            if (this.refs.table){
                this.refs.table.setState({ Data: [] });
            }
        }
    }

    showDocuments(){
        let searchParamsStrings = [];
        searchParamsStrings.push({ TableColumn: "customerId", SearchValue: this.state.SchoolId });
        this.refs.table.setState({ SearchParamsStrings:searchParamsStrings },()=>{
            this.load(this.refs.table.PrepareSendData());
        });
    }

    Delete(e){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        let id = $(e.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;
        this.DocumentsModel.DeleteDocumentByDocumentId(id);
    }

    render()
    {
        return (
          <div className={"form"} >
            <table style={{ width: '600px' }} >
              <tbody>
                <tr>
                  <td
                    colSpan={2}
                    style={{ paddingLeft:'14px' }}><SelectField
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      Width={360}
                      ref={"school"}
                      Id={"Schools2"}
                      Editable={true} 
                      IsRequired={false}
                      Tooltip={Vas.Resources.Tooltips["School"]}
                      Label={Vas.Resources.Labels["School"]}
                      OnChange={()=>{this.setState({ SchoolId: $("#Schools2").val(),School:true },()=>{this.showDocuments();});}}
                      Float={"Left"} /></td>
                </tr>
                <tr>
                  <td>
                    <PagingTable 
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table" 
                      TableReference={this} 
                      DataBaseTable={"Dokumente"} 
                      Selectable={false} 
                      Limit={this.state.Limit} 
                      Start={this.state.Start} 
                      End={this.state.End} 
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["DocumentName"],Vas.Resources.Labels["Size"],Vas.Resources.Labels["Action"]]}
                      Keys={["FileName","FileSize"]} 
                      Data={this.state.Data}
                      Download={true} 
                      DownloadType={"Document"} 
                      Modus={"DBBus"}
                      Add={true} 
                      AddClick={()=>{this.Upload();}}
                      Border={false}
                      LabelPage={Vas.Resources.Labels["Page"]} 
                      LabelOf={Vas.Resources.Labels["Of"]} 
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      AppURL={Vas.ApplicationUrl} 
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      Delete={true}
                      DeleteOnClick={(e)=>{this.Delete(e);}}
              />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default DocumentUpload;
